import { InfoCircleOutlined } from '@ant-design/icons';
import React from 'react';
import { HintBlockType } from './types';

export const HINT_BLOCK_TYPE_ICON_DICT: Record<HintBlockType, React.ReactNode> = {
  info: <InfoCircleOutlined className='hint-block__icon hint-block__icon--info' />,
};
